import { Link } from "react-router-dom";

// Customer-site footer: logo + contact + legal nav. Brand voice
// rule: no patriotic chrome, copy stays imperative and plain.
//
// Phase 4e CO-only storefront — neutral "Contact" framing without
// the internal "yard" vocabulary; one operating region (Colorado),
// one phone number.
//
// Phase 4e brand-visual-rollout FR-9 / FR-16 — logo placement on
// the left rail and the flag-navy hairline above the legal links
// (one of the two allowed flag-navy placements; the other is the
// home-page hero badge in catalog/HomePage.tsx).
export function Footer(): JSX.Element {
  return (
    <footer className="border-t border-zinc-200 bg-brand-white">
      <div className="mx-auto max-w-6xl px-4 py-8 text-sm text-zinc-700 md:px-6">
        {/* Phase 4e brand-visual-rollout FR-9 — logo on the left rail
            replaces the old text-only copyright line; the © now sits
            beneath the logo. */}
        <div className="mb-6 flex flex-col gap-2">
          <img
            src="/brand/jdr-logo-web.png"
            srcSet="/brand/jdr-logo-web.png 1x, /brand/jdr-logo-web@2x.png 2x"
            alt="JDR Equipment Rentals"
            width={96}
            className="h-auto w-24"
          />
          <p className="text-xs text-zinc-500">
            © {new Date().getFullYear()} JDR, LLC. All rights reserved.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          <section>
            <h2 className="text-xs font-semibold uppercase tracking-wide text-zinc-500">
              Contact
            </h2>
            <ul className="mt-2 space-y-2">
              <li>
                <p className="font-medium text-brand-black">Phone</p>
                <p>
                  <a className="text-brand-red hover:underline" href="tel:+13034354328">
                    303-435-4328
                  </a>
                </p>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xs font-semibold uppercase tracking-wide text-zinc-500">
              Browse
            </h2>
            <ul className="mt-2 space-y-2">
              <li>
                <Link to="/" className="hover:underline">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/search" className="hover:underline">
                  Search equipment
                </Link>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xs font-semibold uppercase tracking-wide text-zinc-500">
              Account
            </h2>
            <ul className="mt-2 space-y-2">
              <li>
                <Link to="/sign-in" className="hover:underline">
                  Sign in
                </Link>
              </li>
              <li>
                <Link to="/cart" className="hover:underline">
                  Cart
                </Link>
              </li>
            </ul>
          </section>
        </div>

        {/* Phase 4e brand-visual-rollout FR-16 — the second of the two
            allowed flag-navy placements: a hairline separator above
            the legal links. No flag fill, no stars — just the
            brand-allowed accent color in a 1-pixel rule. */}
        <hr
          data-brand-hairline="flag-navy"
          className="mt-8 border-0 border-t border-flag-navy/60"
          aria-hidden="true"
        />

        <div className="mt-4 flex flex-col gap-2 text-xs text-zinc-500 md:flex-row md:items-center md:justify-between">
          <nav aria-label="Legal" className="flex flex-wrap gap-4">
            <Link to="/terms" className="hover:underline">Terms</Link>
            <Link to="/privacy" className="hover:underline">Privacy</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
